import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------------- English ------------------------------------- */

i18next.addResources(locales.EN, 'SIDEBAR', {
  DASHBOARD: 'Dashboard',
  USERS: 'Users',
  SERVICES: 'Services',
  BLOGS: 'Blogs',
});

/* ------------------------------------- Spanish ------------------------------------- */

i18next.addResources(locales.ES, 'SIDEBAR', {
  DASHBOARD: 'Dashboard',
  USERS: 'Usuarios',
  SERVICES: 'Servicios',
  BLOGS: 'Blogs',
});
